/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/registers',
  name: 'Registers',
  component: () => import('@/views/sabtenam/Index'),
}, {
  path: '/registers-history',
  name: 'RegistersHistory',
  component: () => import('@/views/sabtenam/History'),
}]
